let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hcVmM")).then(() => parcelRequire('gLvZ4'));